import { gql } from '@apollo/client';

const RECENT_INBOX_QUERY = gql`
  query recentInbox($id: ID!) {
    report(id: $id) {
      id
      reportId
      type
      start
      stop
      statusReport
      lastStatusReportAt
      hasSignature
      study {
        id
        friendlyId
        deviceId
        externalSource {
          provider
          externalId
        }
        start
        stop
        status
        reportDueDate
        timezone
        studyTimeOffset
        isNonPhi
        facility {
          id
          name
          arrears
          timezone
        }
        info {
          interprettingPhysician {
            id
            firstName
            lastName
          }
          patient {
            firstName
            lastName
            patientId
          }
        }
        facility {
          id
          name
          contact {
            phone1
            country
            address
            city
            zip
            state
          }
        }
        studyType
        timezone
        isBiofluxDirect
        device {
          model
        }
      }
      event {
        id
        friendlyId
        hasClinicData
        comments
      }
      technicianComments
      findings
      physicianInterpretation
      inbox {
        date
        priority
        isReviewed
        isRead
      }
      isArtifactReport
      isNewFormat
      formatVersion
      aiFormatVersion
      profile
      status
      lastModified
      isRenderingBackground
      reportFindings
      totalStrips
    }
  }
`;

export default RECENT_INBOX_QUERY;
